"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var object_1 = require("./object");

var ObjectClassCache =
/*#__PURE__*/
function () {
  function ObjectClassCache() {
    _classCallCheck(this, ObjectClassCache);

    this.cache = new WeakMap();
  }
  /** Clear the cache */


  _createClass(ObjectClassCache, [{
    key: "clear",
    value: function clear() {
      this.cache = new WeakMap();
    }
  }, {
    key: "hasClass",
    value: function hasClass(state) {
      return this.cache.has(state);
    }
  }, {
    key: "getMarkClass",
    value: function getMarkClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getGlyphClass",
    value: function getGlyphClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getPlotSegmentClass",
    value: function getPlotSegmentClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getChartElementClass",
    value: function getChartElementClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getScaleClass",
    value: function getScaleClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getChartClass",
    value: function getChartClass(state) {
      return this.getClass(state);
    }
  }, {
    key: "getClass",
    value: function getClass(state) {
      if (this.cache.has(state)) {
        return this.cache.get(state);
      } else {
        throw new Error("class not found for state");
      }
    }
  }, {
    key: "createMarkClass",
    value: function createMarkClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createGlyphClass",
    value: function createGlyphClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createPlotSegmentClass",
    value: function createPlotSegmentClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createChartElementClass",
    value: function createChartElementClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createScaleClass",
    value: function createScaleClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createChartClass",
    value: function createChartClass(parent, object, state) {
      return this.createClass(parent, object, state);
    }
  }, {
    key: "createClass",
    value: function createClass(parent, object, state) {
      var newClass = object_1.ObjectClasses.Create(parent, object, state);
      this.cache.set(state, newClass);
      return newClass;
    }
  }]);

  return ObjectClassCache;
}();

exports.ObjectClassCache = ObjectClassCache;